@if (config) {
<div
  class="select-wrapper"
  [class.disabled]="config?.disabled"
  [class.has-errors]="(isInvalid$ | async) || hasErrors"
>
  @if (config?.labelText || config?.topCaption) {
  <div class="top-wrapper">
    <label class="body-s label-text semibold">{{ config?.labelText | translate }}</label>
    <span class="top-caption">{{ config?.topCaption | translate }}</span>
  </div>
  }
  <div #wrapper class="input-wrapper" [class.disabled]="config?.disabled">
    <mat-select
      #select
      disableRipple="true"
      disableOptionCentering="true"
      hideSingleSelectionIndicator="true"
      panelClass="select-custom"
      [uiMaskPii]="config?.shouldMaskPii"
      [formControl]="control"
      [placeholder]="config?.placeholder | translate"
      [panelWidth]="wrapper.clientWidth + panelWidthBorderCompensation"
      [mkpDataTest]="config?.dataTest"
      [trackingDisabled]="true"
    >
      @if (select.value) { @let selectedOption = findOption(select.value);
      <mat-select-trigger>
        @if (selectedOption?.asset) {
        <ui-asset
          [name]="selectedOption.asset.name"
          [set]="selectedOption.asset.set ?? 'icons'"
          [styles]="selectedOption.asset.styles ?? {}"
        />
        } <span [innerHtml]="selectedOption?.name | translate"></span>
      </mat-select-trigger>
      } @for (option of config.options; track option.id; let i = $index) {
      <mat-option mkpDataTest="{{config?.dataTest}}-{{i}}" [value]="option.id">
        <span>
          @if (option.asset) {
          <ui-asset
            [name]="option.asset.name"
            [set]="option.asset.set ?? 'icons'"
            [styles]="option.asset.styles ?? {}"
          />
          } <span [innerHtml]="option.name | translate"></span>
        </span>
      </mat-option>
      }
    </mat-select>
  </div>
  @if (bottomCaption$ | async; as bottomCaption) {
  <div class="bottom-wrapper">
    <span class="bottom-caption">{{ bottomCaption | translate }}</span>
  </div>
  }
</div>
}
